/**
 * Auth slice selectors - centralized state selection.
 * Use these for consistent access to auth state across components.
 */
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuth = (state) => state.auth;
